<style lang='scss' src='./TaskBoard.scss' scoped ></style>
<template src='./TaskBoard.html'></template>

<script>
import {
  mapState,
  mapActions,
} from 'vuex';
import { DeleteTask, getTaskReport } from '@/api/index';
import { cloneDeep } from 'lodash';
import SecurityComponent from '@/components/SecurityComponent.vue';
import TaskList from './components/DraggableTaskList';
import TaskDetails from '@/views/task/details/TaskDetails.vue';
import moment from 'moment';
import VueContext from 'vue-context';
import  'vue-context/dist/css/vue-context.css';
import i18n from './../../../i18n';

export default {
  name: 'TaskBoard',
  extends: SecurityComponent,
  components: {
    TaskList,
    TaskDetails,
    VueContext,
  },
  data() {
    return ({
      enviroment: process.env.VUE_APP_SENTRY_ENV,
      heightListsContainer: 700,
      refreshDataInterval: null,
      filters: {
        user: null,
      },
      isStaffUser: false,

      options: [
                { text: this.$t('timePeriods.1DLong'), label: this.$t('timePeriods.last24H'), value: 1, },
                { text: this.$t('timePeriods.2DLong'), label: this.$t('timePeriods.last2D'), value: 2, },
                { text: this.$t('timePeriods.1WLong'), label: this.$t('timePeriods.lastWeek'), value: 7, },
                { text: this.$t('timePeriods.1MLong'), label: this.$t('timePeriods.lastMonth'), value: 30, },
                { text: this.$t('timePeriods.1QLong'), label: this.$t('timePeriods.lastQuarter'), value: 90, },
                { text: this.$t('timePeriods.1YLong'), label: this.$t('timePeriods.lastYear'), value: 365, },
                { text: this.$t('general.all'), label: this.$t('general.all'), value: 0, },
            ],
      loading_tasks: false,
      timeFrame: null,
      pdfName: null,
    });
  },
  computed: {
    ...mapState('TaskBoard', {
      tasks: (state) => state.tasks,
      users: (state) => state.users,
      loading: (state) => state.loading,
    }),
  },

  methods: {

    showExportModal() {
      this.$bvModal.show('modal-export-tasks')
    },

    searchTasks(showLoading) {
      let userId = this.filters.user ? this.filters.user.user_id : null;
      if (this.isStaffUser) {
        userId = this.$store.state.user.user_id;
      }
      this.loadAllTasks({userId: userId, showLoading: showLoading});
    },

    startIntervalToRefreshData() {
      this.refreshDataInterval = window.setInterval(()=>{this.searchTasks(false)}, process.env.VUE_APP_REFRESH_DATA_TIME_MS);
    },
    onSelectTask(task) {
      this.$refs.taskDetails.openModal(cloneDeep(task));
    },
    onDeleteTask(task) {
      this.G_Alert({ type: this.consts.DialogType.CONFIRM, 
                      style: this.consts.Style.INFO, message: 'Do you really want to delete this task?',
                      backdropClose: true, fnOk: async () => {
                        await DeleteTask(task.task_id);
                        this.deleteTask(task);
                      }});
    },
    ...mapActions('TaskBoard', ['loadAllTasks', 'deleteTask', 'loadUsers', 'loadUsersCustomer']),

    async downloadTasks() {
      this.loading_tasks = true;
      let course_id = this.$store.state.course.course_id
      let until = this.timeFrame ? this.timeFrame : 0;
      await getTaskReport(course_id, until).then((res) => {
        if(!res.count){
          this.$notify({
            text: i18n.t('tasks.noTasksReport'),
            type: 'error',
          });
          return false;
        }

        let tasks = res.tasks;

        this.csvExport(tasks);

        this.loading_tasks = false;  
      });
      this.loading_tasks = false;
    },

    csvExport(data) {
      let csvContent = "data:text/csv;charset=utf-8,";
      let arrData = this.getCsvAllData(data);
      
      if(arrData.length > 0){
        csvContent += [
          Object.keys(arrData[0]).join(","),
          ...arrData.map(item => Object.values(item).join(","))
        ]
        .join("\n")
        .replace(/(^\[)|(\]$)/gm, "");

        const content = encodeURI(csvContent);
        const fixedContent = content.replaceAll('#', '%23');
        const link = document.createElement("a");
        link.setAttribute("href", fixedContent);
        link.setAttribute("download", this.pdfName + ".csv");
        link.click();
      }
    },

    getCsvAllData(items){
      if(items.length>0){
          let data = [];
          items.forEach((item)=>{
              let obj = {}
              //obj[i18n.t('general.timeFrame')] = '';
              obj[i18n.t('reports.filters')] = '';
              
              let time_created = this.G_formatDate({date: (item.time_created), pretty: false});
              obj[i18n.t('general.timeCreated')] = time_created ? time_created.replace(/,/g, "") : time_created;

              obj[i18n.t('tasks.task')] = '"'+item.description+'"';
              obj[i18n.t('tasks.createdBy')] = '"'+this.getCreatorUser(item)+'"';
              obj[i18n.t('tasks.assignedTo')] = '"'+this.getAssignedUsers(item)+'"';
              obj[i18n.t('tasks.activity')] = '"'+this.getActivity(item)+'"';
              obj[i18n.t('tasks.materialsNeeded')] = '"'+(item.materials ? item.materials : '-')+'"';
              obj[i18n.t('general.status')] = i18n.t('taskStatus.'+item.status);

              let time_updated = this.G_formatDate({date: (item.time_updated), pretty: false});
              obj[i18n.t('general.lastUpdated')] = time_updated ? time_updated.replace(/,/g, "") : time_updated;
              
              data.push(obj);
          })

          let headers = [];
          let filters = this.getHeadersObj();
          headers.push(filters);
          return [...headers, ...data];
      }
      return [];
    },

    getActivity(task){
      let activity = '';
      if(task.activity){
        if(task.activity.i18n && task.activity.i18n.length > 0){
          let text = task.activity.i18n.find((item)=>{
            if(item.language == this.$i18n.locale){
              return item
            }    
          })

          if(text){
            return text.i18n
          }else{
            return task.activity.name
          }
        }else{
          return task.activity.name
        };
      }else{
        activity = '-';
      }
      return activity;
    },

    getCreatorUser(task){
      let creator = '';
      if(task.creator){
        creator = task.creator.name + (task.creator.last_name ? (' ' + task.creator.last_name) : '')
      }else{
        creator = '-';
      }
      return creator;
    },

    getAssignedUsers(task){
      let assigend = '';
      if(task.users){
        task.users.forEach((item, idx) => {
          assigend += (idx > 0 ? ', ' : '') + item.name + (item.last_name ? (' ' + item.last_name) : '')
        });
      }else{
        assigend = i18n.t('tasks.unAssigned');
      }
      return assigend;
    },

    getHeadersObj(){
      let timeFrame = this.options.find(x => x.value == this.timeFrame);
      timeFrame = timeFrame ? timeFrame.text : '';
      
      let obj = {}
      //obj[i18n.t('general.timeFrame')] = timeFrame;
      obj[i18n.t('reports.filters')] = i18n.t('general.timeFrame') + ': ' + timeFrame;
      obj[i18n.t('general.timeCreated')] = '';
      obj[i18n.t('tasks.task')] = '';
      obj[i18n.t('tasks.createdBy')] = '';
      obj[i18n.t('tasks.assignedTo')] = '';
      obj[i18n.t('tasks.activity')] = '';
      obj[i18n.t('tasks.materialsNeeded')] = '';
      obj[i18n.t('general.status')] = '';
      obj[i18n.t('general.lastUpdated')] = '';

      return obj
    },
  },

  beforeCreate() {},

  created() {
    let date = new Date();
    date = moment(date).format("MM-DD-YYYY");
    this.pdfName = i18n.t('tasks.tasks') + ' ' + date;
  },

  mounted() {
    this.timeFrame = this.options[0].value;
    this.isStaffUser = this.$store.state.user.type_id == this.consts.UserType.STAFF || this.$store.state.user.type_id == this.consts.UserType.IRRIGATION_SPECIALIST ;
    this.heightListsContainer = (window.innerHeight) - (this.$refs.taskListsContainer.getBoundingClientRect().top);
    this.searchTasks(true);
    
    if (this.$store.state.user.user_type.type_id == this.consts.UserType.ADMIN ||
        this.$store.state.user.user_type.type_id == this.consts.UserType.OPERATIONS){
      this.loadUsers();
    } else {
      this.loadUsersCustomer();
    }
    
    this.startIntervalToRefreshData();
  },

  beforeDestroy() {
    window.clearInterval(this.refreshDataInterval);
  },

};
</script>
